import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { List, ListItem } from "@mui/material";
import "../../assets/css/footer.css";
import NavBarLandingPage from "./NavBarLandingPage";
import TermsConditionVector from "../../assets/images/termsandconditionvector.png";
import FooterLandingpage from "./FooterLandingpage";
function Shipping() {
  const stylesMain = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "2.5rem",
      fontWeight: 700,
      lineHeight: "100%",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "2.2rem",
        lineHeight: "100%",
      },
    },
  };
  const styles = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "2.5rem",
      fontWeight: 600,
      lineHeight: "25px",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "2.5rem",
        lineHeight: "48px",
        marginTop: "0px",
      },
    },
  };
  const description = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: 18,
      fontWeight: 400,
      lineHeight: "28px",
      letterSpacing: "0em",
      textAlign: "left",

      "@media (max-width: 600px)": {
        fontSize: "1.2rem", // Adjust the font size for smaller screens
        lineHeight: "26px", // Adjust other styles as needed
        textAlign: "start",
      },
    },
  };
  return (
    <div>
      <NavBarLandingPage />
      <div className="cancellation-and-refund-background landing-page">
        <Box
          sx={{
            backgroundColor: "#1E53E8",
            borderRadius: "30px",
            padding: "3rem",
            margin: "40px",
            position: "relative",
            "@media (max-width: 1024px)": {
              margin: "32px",
              padding: "50px 30px",
            },
            "@media (max-width: 600px)": {
              padding: "1.5rem",
              margin: "0px",
              borderRadius: "22px",
            },
          }}
        >
          <Typography
            sx={{
              ...stylesMain.typography,
              color: "#fff",
              textTransform: "uppercase",
              // marginTop: "30px,
              height: "50px",
            }}
          >
            Shipping and Delivery policy{" "}
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: "#FFFFFF",
              // marginTop: "12px",
              "@media (max-width: 600px)": {
                fontSize: "1rem", // Adjust the font size for smaller screens
                lineHeight: "26px", // Adjust other styles as needed
                marginTop: "40px",
              },
            }}
          >
            Learn about our fast and secure delivery process for your Cloud PC.
          </Typography>
          <img
            src={TermsConditionVector}
            alt=""
            style={{ position: "absolute", right: "0", bottom: "0" }}
          />
        </Box>
        <Box
          sx={{
            borderRadius: "30px",
            backgroundColor: " #F1F1F1",
            padding: "3rem",
            // marginTop: "2rem",
            marginBlockEnd: "6rem",
            margin: "40px",
            "@media (max-width: 1024px)": {
              margin: "32px",
              padding: "30px",
            },
            "@media (max-width: 600px)": {
              padding: "1.8rem",
              margin: "0px",
              borderRadius: "22px",
              marginTop:"20px"
            },
          }}
        >
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "0px",
              "@media (max-width: 900px)": {
                // marginTop:"15px"
              },
             }}
          >
            International Buyers
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              "@media (max-width: 600px)": {
                marginTop:"0px"
              },
            }}
          >
            <ul className="custom-ul">
              <li >
                Orders are shipped and delivered through registered
                international courier companies and/or International speed post
                only.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Domestic Buyers
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: "#000000",
              // marginTop: "16px",      
              "@media (max-width: 600px)": {
                marginTop:"0px"
              },
            }}
          >
            <ul className="custom-ul">
              <li style={{  listStyleType: "disc" }}>
                Orders are shipped through registered domestic courier companies
                and/or speed post only.
              </li>
            </ul>
          </Typography>

          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Delivery Time
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              // marginTop: "16px",
              "@media (max-width: 600px)": {
                marginTop:"0px"
              },
            }}
          >
            <ul className="custom-ul">
              <li style={{ marginBottom: "10px" }}>
                Orders are shipped within 3-5 days or as per the delivery date
                agreed at the time of order confirmation, subject to Courier
                Company / post office norms.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Delivery Responsibility
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              "@media (max-width: 600px)": {
                marginTop:"0px"
              },
            }}
          >
            <ul className="custom-ul">
              <li style={{ marginBottom: "10px" }}>
                MEGACONNECT TECHNOLOGIES PRIVATE LIMITED guarantees to hand over
                the consignment to the courier company or postal authorities
                within 3-5 days from the date of the order and payment or as per
                the agreed delivery date. The company is not liable for any
                delay in delivery by the courier company / postal authorities.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Delivery Address
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              "@media (max-width: 600px)": {
                marginTop:"0px"
              },
            }}
          >
            <ul className="custom-ul">
              <li style={{ marginBottom: "10px" }}>
                Delivery of all orders will be made to the address provided by
                the buyer.
              </li>
            </ul>
          </Typography>

          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Confirmation
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              "@media (max-width: 600px)": {
                marginTop:"0px"
              },
            }}
          >
            <ul className="custom-ul">
              <li style={{ marginBottom: "10px" }}>
                Delivery of our services will be confirmed on your mail ID as
                specified during registration.
              </li>
            </ul>
          </Typography>

          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Contact
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              "@media (max-width: 600px)": {
                marginTop:"0px"
              },
            }}
          >
            <ul className="custom-ul">
              <li style={{ marginBottom: "10px" }}>
                For any issues in utilizing our services, you may contact our
                helpdesk at 6360003712 or support@megaconnect.cloud
              </li>
            </ul>
          </Typography>
        </Box>
      </div>
      <FooterLandingpage />
    </div>
  );
}

export default Shipping;
